var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4513 7.4407H14.209C13.478 7.4407 12.8854 8.04246 12.8854 8.7847C12.8854 9.52695 13.478 10.1287 14.209 10.1287H19.0624C19.7934 10.1287 20.386 9.52695 20.386 8.7847V2.9607C20.386 2.21844 19.7934 1.6167 19.0624 1.6167C18.3314 1.6167 17.7387 2.21844 17.7387 2.9607V4.3039C16.129 2.12798 13.5666 0.720703 10.6795 0.720703C7.9671 0.720703 5.55411 1.90407 3.92562 3.89365C3.45837 4.46451 3.53536 5.3119 4.09757 5.78633C4.65978 6.26085 5.4943 6.18254 5.96157 5.61175C7.08475 4.23949 8.75034 3.4087 10.6795 3.4087C13.3132 3.4087 15.5634 5.08318 16.4513 7.4407ZM3.61993 16.4007V15.0567C5.22936 17.2327 7.79168 18.6407 10.6795 18.6407C13.3711 18.6407 15.8046 17.415 17.4235 15.4814C17.897 14.9159 17.8294 14.0677 17.2724 13.5869C16.7155 13.1061 15.8802 13.1749 15.4066 13.7405C14.274 15.0933 12.5689 15.9527 10.6795 15.9527C8.21683 15.9527 6.08823 14.4885 5.09656 12.3687H7.14963C7.88063 12.3687 8.47326 11.7669 8.47326 11.0247C8.47326 10.2825 7.88063 9.6807 7.14963 9.6807H2.29629C1.56527 9.6807 0.972656 10.2825 0.972656 11.0247V16.4007C0.972656 17.143 1.56527 17.7447 2.29629 17.7447C3.02731 17.7447 3.61993 17.143 3.61993 16.4007Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.f7d01a5b51878559fdcc9dd8f243a420.svg";
export { ForwardRef as ReactComponent };